import { UserProfile } from '@dc-shared-web/hooks/api/user/types'
import { AxiosInstance } from 'axios'

export type UpdateUserProfileParams = {
  uuid: string
} & Pick<UserProfile, 'firstName' | 'lastName' | 'jobTitle' | 'phone1'>

export const updateUserProfile: (
  apiClient: AxiosInstance,
  params: UpdateUserProfileParams
) => Promise<UserProfile> = async (apiClient, { uuid, ...rest }) => {
  const { data: axiosData } = await apiClient.patch(
    `/api/users/${uuid}/profile`,
    {
      ...rest,
    }
  )

  return axiosData.data
}
